import { AxiosResponse } from 'axios';
import { appContextPost } from './httpCommon/appAxios.service';
import { BILLING_ENDPOINTS } from '../constants/apiEndpoints';

export const downloadBillingReport = (): Promise<AxiosResponse<any, any>> => {
  return appContextPost(BILLING_ENDPOINTS.DOWNLOAD_REPORT, {}, {}, { responseType: 'blob' });
};
